import React from 'react';
import PropTypes from 'prop-types';
import { Select, MenuItem, FormControl, InputLabel } from '@mui/material';

const CompanyTypeInput = ({ input, obj, handleInfoFunc }) => (
  <FormControl sx={input.sx}>
    <InputLabel id="company-type-input-label">{input.label}</InputLabel>
    <Select
      id={input.id}
      label={input.label}
      onChange={(e) => handleInfoFunc(input.id, e.target.value, obj.id)}
      value={obj[input.id]}
    >
      <MenuItem value="ACTION_SOCIETY">Soc. por Acciones</MenuItem>
      <MenuItem value="LIMITED_SOCIETY">Soc. Limitada</MenuItem>
      <MenuItem value="INDIVIDUAL_SOCIETY">E.I.R.L.</MenuItem>
    </Select>
  </FormControl>
);

CompanyTypeInput.propTypes = {
  input: PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
    disabled: PropTypes.bool,
    sx: PropTypes.shape({
      width: PropTypes.string,
    }),
    inputProps: PropTypes.shape({
      style: PropTypes.shape({
        textTransform: PropTypes.string,
      }),
    }),
  }).isRequired,
  obj: PropTypes.shape({
    id: PropTypes.number,
    rut: PropTypes.string,
    mainDisabled: PropTypes.bool,
  }).isRequired,
  handleInfoFunc: PropTypes.func.isRequired,
};

export default CompanyTypeInput;
